import React, { useEffect, useState } from 'react';
import { Modal, Form, message } from 'antd';
import ETLMappingEditor from './ETLMappingEditor';
import { fetchSchemaById, saveMappingToBackend } from '../services/api';
import {useToast} from "../ToastProvider";

function TransformMappingModal({ open, onCancel, onSave, initialSchemaId = null }) {
    const [mapping, setMapping] = useState([]);
    const [schemaName, setSchemaName] = useState('');

    useEffect(() => {
        if (initialSchemaId) {
            fetchSchemaById(initialSchemaId)
                .then((res) => {
                    const schema = res.data;
                    setMapping(schema.fieldMapping || []);
                    setSchemaName(schema.name || '');
                })
                .catch(() => {
                    message.error('Không thể tải schema!');
                });
        }
    }, [initialSchemaId]);
    const { addToast } = useToast();

    const handleOk = async () => {
        try {
            await saveMappingToBackend({ schemaId: initialSchemaId, fieldMapping: mapping });
            addToast('Lưu mapping thành công!', 'success');

            // Gọi onSave trước
            onSave?.({ schemaId: initialSchemaId, fieldMapping: mapping });

            // Đợi toast hiển thị xong rồi mới đóng modal
            setTimeout(() => {
                onCancel();
            }, 1500); // 1.5s là thời gian toast mặc định của Ant Design
        } catch (err) {
            addToast('Có lỗi xảy ra!', 'error');
        }
    };


    return (
        <Modal
            title="Mapping Transform Schema"
            open={open}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Lưu Mapping"
            width={800}
        >
            <Form.Item label="Schema sử dụng">
                <div style={{ fontWeight: 500 }}>{schemaName || 'Không có schema'}</div>
            </Form.Item>
            <ETLMappingEditor
                initialFieldMapping={mapping}
                onMappingChange={setMapping}
            />
        </Modal>
    );
}

export default TransformMappingModal;
